import React from 'react';
import { Link } from 'react-router-dom';
import LazyLoad from 'react-lazyload';
import { updateLocationSearch } from 'utils/url';
import UpdateCartButton from '../UpdateCartButton/UpdateCartButton';
import styles from './SponsoredProduct.module.css';

const SponsoredProduct = (props) => {
  const {
    sponsoredThreshold,
    subtotal,
    viewSize,
    version,
    shareUrl,
    name,
    variants,
    gwpProducts,
  } = props;
  const variant = variants[0];
  return (
    <li className={`${styles.productContainer} ${styles[viewSize]}`}>
      <Link
        to={updateLocationSearch(
          {
            product_link: shareUrl,
          },
          { accordionInGrid: true }
        )}
      >
        <span className="sr-only">Click to read product details</span>
        <div className={styles.imageContainer}>
          <LazyLoad once>
            <img
              className={styles.image}
              alt={`${name}`}
              src={variant.imageUrl}
            />
          </LazyLoad>
        </div>
      </Link>
      <div className={styles.textContainer}>
        <Link
          to={updateLocationSearch(
            {
              product_link: shareUrl,
            },
            { accordionInGrid: true }
          )}
        >
          <span className={styles.name}>{name}</span>
        </Link>

        <span className={styles.price}>$0 - Free with Qualified Purchase</span>
      </div>

      <div className={styles.buttonContainer}>
        <UpdateCartButton
          productName={name}
          sponsored
          sponsoredThreshold={sponsoredThreshold}
          subtotal={subtotal}
          nonColorVariant={false}
          shareUrl={shareUrl}
          version={version}
          viewSize={viewSize}
          isAccordion={false}
          variant={variant}
          gwpProducts={gwpProducts}
        />
      </div>
    </li>
  );
};

export default SponsoredProduct;
